
export function Toggle({ checked, onChange, label, description, disabled = false }) {
  return (
    <label className={`cfd-toggle-row${disabled ? " is-disabled" : ""}`}>
      <span>
        <strong>{label}</strong>
        {description ? <small>{description}</small> : null}
      </span>
      <input
        type="checkbox"
        checked={Boolean(checked)}
        onChange={(event) => onChange(event.target.checked)}
        disabled={disabled}
      />
      <span className="cfd-switch" aria-hidden="true" />
    </label>
  );
}

export function ColorSetting({ label, value, onChange }) {
  return (
    <label className="cfd-setting-row">
      <span>{label}</span>
      <span className="cfd-color-control">
        <input type="color" value={value} onChange={(event) => onChange(event.target.value)} />
        <input
          type="text"
          value={value}
          maxLength={7}
          onChange={(event) => onChange(event.target.value)}
          aria-label={`${label} hex color`}
        />
      </span>
    </label>
  );
}

export function NumberSetting({ label, value, onChange, min, max, suffix = "px" }) {
  return (
    <label className="cfd-setting-row">
      <span>{label}</span>
      <span className="cfd-number-control">
        <input
          type="number"
          value={value}
          min={min}
          max={max}
          onChange={(event) => onChange(event.target.value)}
        />
        <em>{suffix}</em>
      </span>
    </label>
  );
}
